export { Platform } from './platform';
export { getSupportedInputTypes } from './features';



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/platform/index.js
// module id = 1357
// module chunks = 31